const baseUrl = process.env.REACT_APP_RD_API_URL || 'https://rd.venturit.org/';

const rootParams = {
  rootUrl: baseUrl,
};

export default rootParams;
